import { error, finish } from '../../../modules/liabilities/actions/multiples';
import api from '../../../api';

export function request(dispatch) {
    api.get('/liabilities-alerts/multiples', void 0).then(
        result => dispatch(finish(result ? result.lines : [])),
        errors => dispatch(error(errors))
    );
}
